import { Button, Heading, Text } from '@mallpay/orbis';
import React from 'react';

import { ReactComponent as IconCross } from '@skippay/core/assets/icons/icon-cross-circle-coloured.svg';
import { usePageview } from '@skippay/core/components/GoogleAnalytics';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import { OVERVIEW } from 'constants/routes';
import { FooterButtons } from 'layout/MinimalLayout/components/FooterButtons';

function Rejected(): JSX.Element {
	usePageview({ pTitle: 'bnpl_limit_management_rejected' });

	return (
		<section className="mx-auto px-4 pt-6 pb-8">
			<div className="flex flex-col gap-8">
				<Text as="div" className="text-center">
					<IconCross className="h-20 w-20" />
				</Text>

				<div className="flex flex-col gap-3">
					<Heading as="h1" className="text-center">
						<FormattedMessage
							id="BnplLimitManagement.rejected.title"
							defaultMessage="Neklaplo to"
						/>
					</Heading>

					<div className="mt-4">
						<Text as="div" className="text-center">
							<FormattedMessage
								id="BnplLimitManagement.rejected.description"
								defaultMessage="Limity vám teď nemůžeme poskytnout. "
							/>
						</Text>
					</div>
				</div>
			</div>

			<FooterButtons
				content={
					<Button
						className="w-full"
						testId="bnplRejectedClose"
						analyticsParam="bnplRejectedClose"
						variant="primary"
						to={OVERVIEW}
					>
						<FormattedMessage id="BnplLimitManagement.rejected.close" defaultMessage="Zavřít" />
					</Button>
				}
			/>
		</section>
	);
}

export default Rejected;
